import { render, staticRenderFns } from "./p-error-no-access.vue?vue&type=template&id=0a8f23e6&scoped=true"
import script from "./p-error-no-access.vue?vue&type=script&lang=js"
export * from "./p-error-no-access.vue?vue&type=script&lang=js"
import style0 from "./p-error-no-access.vue?vue&type=style&index=0&id=0a8f23e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8f23e6",
  null
  
)

export default component.exports